document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('img').forEach(function(img){if(!img.hasAttribute('decoding'))img.setAttribute('decoding','async');});
  document.querySelectorAll('iframe').forEach(function(frame){if(!frame.hasAttribute('loading'))frame.setAttribute('loading','lazy');});
  document.querySelectorAll('video').forEach(function(video){if(!video.hasAttribute('preload'))video.setAttribute('preload','metadata');});

  function getCountry(){
    var localizationCountry=document.querySelector('form[action*="/localization"] input[name="country_code"]');
    if(localizationCountry&&localizationCountry.value)return String(localizationCountry.value).toUpperCase();
    if(window.Shopify&&Shopify.country)return String(Shopify.country).toUpperCase();
    if(location.pathname.indexOf('/en-gb')===0)return 'GB';
    return '';
  }

  var country=getCountry();
  if(country==='GB')return;

  var isUS=country==='US';
  var replacements=isUS?[
    ['Free tracked UK delivery','Free tracked US delivery'],
    ['free tracked UK delivery','free tracked US delivery'],
    ['Tracked UK delivery','Tracked US delivery'],
    ['UK delivery','US delivery'],
    ['Secure UK Checkout','Secure US Checkout'],
    ['Secure UK checkout','Secure US checkout'],
    ['GBP pricing','USD pricing'],
    ['current UK pricing','current local pricing'],
    ['Current UK pricing','Current local pricing'],
    ['Free £29 Productivity Pack','Free Productivity Pack'],
    ['free £29 Productivity Pack','free Productivity Pack'],
    ['£29 Professional Productivity Pack','Professional Productivity Pack'],
    ['£29 Productivity Pack','Productivity Pack'],
    ['worth £29','included'],
    ['Worth £29','Included'],
    ['£0 for the first year','$0 for the first year'],
    ['£0 extra for Max','$0 extra for Max'],
    ['Neralvo Halo MagSafe Hardware (£129.99 value)','Neralvo Halo MagSafe Hardware ($129.99 value)'],
    ['1-Year Unmetered DOWAY Max App License (Worth £69.99)','1-Year Unmetered DOWAY Max App License (included)'],
    ['Exclusive Productivity & Automation Pack (Worth £29)','Exclusive Productivity & Automation Pack (included)'],
    ['£69.99/year — equivalent to £5.83/month','See DOWAY for current local annual pricing'],
    ['Or £9.99/month','Monthly option available in DOWAY'],
    ['£29.99/year — equivalent to £2.50/month','See DOWAY for current local annual pricing'],
    ['Or £4.99/month','Monthly option available in DOWAY'],
    ["DOWAY currently lists Max at £69.99/year or £9.99/month and Pro at £29.99/year or £4.99/month.","Check DOWAY for current local Max and Pro pricing after the included first year."]
  ]:[
    ['Free tracked UK delivery','Free tracked worldwide delivery'],
    ['free tracked UK delivery','free tracked worldwide delivery'],
    ['Tracked UK delivery','Tracked worldwide delivery'],
    ['UK delivery','Worldwide delivery'],
    ['Secure UK Checkout','Secure checkout'],
    ['Secure UK checkout','Secure checkout'],
    ['GBP pricing','Local market pricing'],
    ['current UK pricing','current local pricing'],
    ['Current UK pricing','Current local pricing'],
    ['Free £29 Productivity Pack','Free Productivity Pack'],
    ['free £29 Productivity Pack','free Productivity Pack'],
    ['£29 Professional Productivity Pack','Professional Productivity Pack'],
    ['£29 Productivity Pack','Productivity Pack'],
    ['worth £29','included'],
    ['Worth £29','Included'],
    ['£0 for the first year','No extra charge for the first year'],
    ['£0 extra for Max','No extra Max charge'],
    ['Neralvo Halo MagSafe Hardware (£129.99 value)','Neralvo Halo MagSafe Hardware'],
    ['1-Year Unmetered DOWAY Max App License (Worth £69.99)','1-Year Unmetered DOWAY Max App License (included)'],
    ['Exclusive Productivity & Automation Pack (Worth £29)','Exclusive Productivity & Automation Pack (included)'],
    ['£69.99/year — equivalent to £5.83/month','See DOWAY for current local annual pricing'],
    ['Or £9.99/month','Monthly option available in DOWAY'],
    ['£29.99/year — equivalent to £2.50/month','See DOWAY for current local annual pricing'],
    ['Or £4.99/month','Monthly option available in DOWAY'],
    ["DOWAY currently lists Max at £69.99/year or £9.99/month and Pro at £29.99/year or £4.99/month.","Check DOWAY for current local Max and Pro pricing after the included first year."]
  ];

  function normalizeText(root){
    if(!root)return;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      var value=node.nodeValue;
      if(!value||!value.trim())continue;
      var next=value;
      replacements.forEach(function(pair){if(next.indexOf(pair[0])!==-1)next=next.split(pair[0]).join(pair[1]);});
      if(next!==value)node.nodeValue=next;
    }
  }

  normalizeText(document.body);
  var observer=new MutationObserver(function(mutations){
    mutations.forEach(function(mutation){
      mutation.addedNodes.forEach(function(node){
        if(node.nodeType===1)normalizeText(node);
        else if(node.nodeType===3&&node.parentNode)normalizeText(node.parentNode);
      });
    });
  });
  observer.observe(document.body,{childList:true,subtree:true});
});